/*!
 * froala_editor v3.0.4 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2019 Froala Labs
 */
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(require("froala-editor")) : "function" == typeof define && define.amd ? define(["froala-editor"], t) : t(e.FroalaEditor);
}(this, function (e) {
  "use strict";

  e = e && e.hasOwnProperty("default") ? e["default"] : e, Object.assign(e.DEFAULTS, {
    saveInterval: 1e4,
    saveURL: null,
    saveParams: {},
    saveParam: "body",
    saveMethod: "POST"
  }), e.PLUGINS.save = function (i) {
    var v = i.$,
        e = null,
        f = null,
        t = !1,
        u = 1,
        l = 2,
        s = {};

    function c(e, t) {
      i.events.trigger("save.error", [{
        code: e,
        message: s[e]
      }, t]);
    }

    function a(e) {
      void 0 === e && (e = i.html.get());
      var a = e,
          t = i.events.trigger("save.before", [e]);
      if (!1 === t) return !1;

      if ("string" == typeof t && (e = t), i.opts.saveURL) {
        var s = {};

        for (var n in i.opts.saveParams) {
          if (i.opts.saveParams.hasOwnProperty(n)) {
            var o = i.opts.saveParams[n];
            s[n] = "function" == typeof o ? o.call(this) : o;
          }
        }

        var r = {};
        r[i.opts.saveParam] = e, v(this).ajax({
          method: i.opts.saveMethod,
          url: i.opts.saveURL,
          data: Object.assign(r, s),
          crossDomain: i.opts.requestWithCORS,
          withCredentials: i.opts.requestWithCredentials,
          headers: i.opts.requestHeaders,
          done: function done(e, t, s) {
            f = a, i.events.trigger("save.after", [e]);
          },
          fail: function fail(e) {
            c(l, e.response || e.responseText);
          }
        });
      } else c(u);
    }

    function n() {
      clearTimeout(e), e = setTimeout(function () {
        var e = i.html.get();
        (f != e || t) && (t = !1, a(f = e));
      }, i.opts.saveInterval);
    }

    return s[u] = "Missing saveURL option.", s[l] = "Something went wrong during save.", {
      _init: function o() {
        i.opts.saveInterval && (f = i.html.get(), i.events.on("contentChanged", n), i.events.on("keydown destroy", function () {
          clearTimeout(e);
        }));
      },
      save: a,
      reset: function r() {
        n(), t = !1;
      },
      force: function d() {
        t = !0;
      }
    };
  }, e.DefineIcon("save", {
    NAME: "floppy-o",
    FA5NAME: "save"
  }), e.RegisterCommand("save", {
    title: "Save",
    undo: !1,
    focus: !1,
    refreshAfterCallback: !1,
    callback: function callback() {
      this.save.save();
    },
    plugin: "save"
  });
});